import { api } from "@/builders/axios";
import {
  CreateDepartmentData,
  DepartmentData,
} from "@/builders/types/department";

const get = function (id: number) {
  return api
    .get<{
      data: DepartmentData;
    }>(`departments/${id}`)
    .then(({ data }) => data);
};

const put = function (variables: { id: number; data: CreateDepartmentData }) {
  const { id, data } = variables;
  return api.put(`/departments/${id}`, data);
};

const patch = function (id: number, data: { name: string }) {
  return api.patch(`/departments/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/departments/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
